export default __webpack_public_path__ + "static/trees-528d695b34eb94531350c49647fc76cb.webp";